import React from "react";
import { useSelector } from "react-redux";
import { getCustomizeCanvas } from "../../redux/creators/customizeCreators";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faSquareFull,
  faCircle,
  faImage,
  faArrowPointer,
  faT,
} from "@fortawesome/free-solid-svg-icons";
import "../../../../css/customize.css";

/**
 * Handles the customizer's main toolbar.
 *
 * @returns {Object}
 */
export default function Toolbar() {
  const { canvas } = useSelector((state) => ({
    canvas: getCustomizeCanvas(state),
  }));

  // Size for object's transform corners based on canvas size for best visibility
  const getCornerSize = () => {
    let size = canvas.width / 40;
    size = size < 20 ? 20 : size;
    return size;
  };

  const getColor = () => {
    return document.getElementById("colorPicker").value;
  };

  const addRect = () => {
    deselectAll();
    // Calculate initial rectangle width based on canvas size
    let width = canvas.width / 2;
    // Make sure width is at least 100px for visibility
    width = width < 100 ? 100 : width;

    const rectangle = new fabric.Rect({
      width,
      height: width / 2,
      fill: getColor(),
      cornerSize: getCornerSize(),
      cornerColor: "#454545",
      originX: "center",
      originY: "center",
      top: width / 4,
      left: width / 2,
      transparentCorners: false,
    });
    canvas.add(rectangle).setActiveObject(rectangle);
  };

  const addCircle = () => {
    deselectAll();
    // Calculate initial circle radius based on canvas size
    let radius = canvas.width / 4;
    // Make sure radius is at least 50px for visibility
    radius = radius < 50 ? 50 : radius;

    const circle = new fabric.Circle({
      radius,
      fill: getColor(),
      cornerSize: getCornerSize(),
      cornerColor: "#454545",
      transparentCorners: false,
    });
    canvas.add(circle).setActiveObject(circle);
  };

  const addText = () => {
    deselectAll();
    // Calculate initial text size based on canvas size
    let fontSize = canvas.width / 6;
    // Make sure text size is at least 12px for visibility
    fontSize < 12 ? 12 : fontSize;

    const text = new fabric.IText("Start typing...", {
      fontFamily: "arial",
      fill: getColor(),
      fontSize,
      cornerSize: getCornerSize(),
      cornerColor: "#454545",
      transparentCorners: false,
    });
    canvas.add(text).setActiveObject(text);
    text.enterEditing().selectAll();
  };

  const changeColor = () => {
    if (canvas.getActiveObject()) {
      canvas.getActiveObject().set("fill", getColor());
      canvas.renderAll();
    }
  };

  const addImg = (file) => {
    deselectAll();
    const fileUrl = URL.createObjectURL(file);
    new fabric.Image.fromURL(fileUrl, (image) => {
      const heightRatio = canvas.height / image.height;
      const widthRatio = canvas.width / image.width;
      const ratio = heightRatio > widthRatio ? heightRatio : widthRatio;
      image.set({
        scaleX: ratio,
        scaleY: ratio,
        cornerSize: getCornerSize(),
        cornerColor: "#454545",
        transparentCorners: false,
      });
      canvas.add(image).centerObject(image).setActiveObject(image);
      canvas.renderAll();
    });
  };

  const deselectAll = () => {
    canvas.discardActiveObject().renderAll();
  };

  const deleteObject = () => {
    canvas.remove(canvas.getActiveObject());
  };

  const triggerColor = () => {
    document.getElementById("colorPicker").click();
  };

  return (
    <div className="toolbar-container">
      <div className="toolbar">
        <button className="fabric-button" onClick={() => addText()}>
          <FontAwesomeIcon icon={faT} />
          <div className="toolbar-text">Add Text</div>
        </button>

        <button className="fabric-button color-changer">
          <div className="color-changer-inner">
            <input
              type="color"
              id="colorPicker"
              name="head"
              defaultValue="#000000"
              onChange={() => changeColor()}
            ></input>
            <img
              src="https://cdn.shopify.com/s/files/1/0591/4299/6149/files/colorwheel.png"
              onClick={() => triggerColor()}
            ></img>
          </div>
          <div className="toolbar-text">Color</div>
        </button>

        <button className="fabric-button">
          <label className="image-upload">
            <input
              id="fileupload"
              type="file"
              name="fileupload"
              onChange={(e) => addImg(e.target.files[0])}
            />
            <FontAwesomeIcon icon={faImage} />
          </label>
          <div className="toolbar-text">Add Image</div>
        </button>

        <button className="fabric-button" onClick={() => addRect()}>
          <FontAwesomeIcon icon={faSquareFull} />
          <div className="toolbar-text">Rectangle</div>
        </button>

        <button className="fabric-button" onClick={() => addCircle()}>
          <FontAwesomeIcon icon={faCircle} />
          <div className="toolbar-text">Circle</div>
        </button>

        <button className="fabric-button" onClick={() => deselectAll()}>
          <FontAwesomeIcon icon={faArrowPointer} />
          <div className="toolbar-text">Select</div>
        </button>

        <button className="fabric-button" onClick={() => deleteObject()}>
          <FontAwesomeIcon icon={faTrash} />
          <div className="toolbar-text">Delete</div>
        </button>
      </div>
    </div>
  );
}
